/**
 * The rating shown for a store: the average of what customers actually voted.
 *
 * The API sends `avgRating` (average of customer store ratings, "0" when nobody has voted yet)
 * next to `rating` (a static value an admin typed in). A store with no votes shows no rating
 * instead of the typed-in number. Only when the API did not send `avgRating` at all is the
 * static `rating` used, so screens fed by older endpoints still show something.
 *
 * @returns {number|null}
 */
export const getStoreRating = (store) => {
  if (!store) return null;
  const hasAverage = store.avgRating !== undefined && store.avgRating !== null && store.avgRating !== "";
  const value = parseFloat(hasAverage ? store.avgRating : store.rating);
  return Number.isFinite(value) && value > 0 ? value : null;
};

/** "3.1", or null when there is no rating yet. */
export const formatStoreRating = (store) => {
  const value = getStoreRating(store);
  return value === null ? null : value.toFixed(1);
};
